import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19e74788"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative flex h-full border-l" }
const _hoisted_2 = { class: "flex flex-col justify-center w-4/5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-400" }, " Status ", -1))
const _hoisted_4 = {
  key: 0,
  class: "flex flex-row items-center space-x-2"
}
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col justify-center w-4/5"
}
const _hoisted_6 = {
  key: 2,
  class: "flex flex-col justify-center w-4/5"
}
const _hoisted_7 = {
  key: 0,
  class: "flex justify-end items-center w-1/5"
}
const _hoisted_8 = {
  key: 0,
  class: "absolute rounded bg-white p-2 w-48 border rounded top-0 mt-20"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex items-center space-x-2" }

import { computed, PropType, ref } from 'vue';
import { TriageStatus } from '@/models';
import BaseIcon from '@/lib/components/Icon/BaseIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TriageSelect',
  props: {
  options: {
    type: Array as PropType<Array<TriageStatus>>,
    required: true
  },
  modelValue: {
    type: String as PropType<string | null>,
    default: null
  },
  loading: {
    type: Boolean,
    default: false
  },
  readOnly: {
    type: Boolean,
    default: false
  }
},
  emits: ["update:modelValue", "change", "blur"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: string | null): void;
  (e: 'change'): void;
  (e: 'blur'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;




const showOptions = ref(false);

const selectedOption = computed(() => computedOptions.value
  .find((option: TriageStatus): boolean => option.id === props.modelValue)
);
const computedOptions = computed(() => props.options.map((option) => ({
  ...option,
  style: { '--hovercolor': option.color },
  circleStyle: {
    'background-color': `${option.color}`
  }
})));

const selectTriage = async (triageId: string) => {
  await emit('update:modelValue', triageId);
  await emit('change');
  showOptions.value = false;
};
const toggleShowOptions = () => {
  if (!props.readOnly) {
    showOptions.value = !showOptions.value;
  }
};
const clickAway = () => {
  if (!props.readOnly) {
    showOptions.value = false;
    emit('blur');
  }
};

return (_ctx: any,_cache: any) => {
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex items-center py-2 px-4 w-48 h-full font-semibold", {
        'hover:bg-gray-200 cursor-pointer': !__props.readOnly
      }]),
      onClick: toggleShowOptions
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_unref(selectedOption) && !__props.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "rounded-full h-2 w-2",
                style: _normalizeStyle(_unref(selectedOption).circleStyle)
              }, null, 4),
              _createElementVNode("div", null, _toDisplayString(_unref(selectedOption).name), 1)
            ]))
          : (__props.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('platform.common.loading')) + "...", 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('custom.uhb.consult.no-triage-set')), 1)
              ]))
      ]),
      (!__props.readOnly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (!showOptions.value)
              ? (_openBlock(), _createBlock(BaseIcon, {
                  key: 0,
                  name: "chevron-down"
                }))
              : (_openBlock(), _createBlock(BaseIcon, {
                  key: 1,
                  name: "chevron-up"
                }))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (showOptions.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(computedOptions), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "rounded triage h-10 bg-white cursor-pointer px-4 flex items-center font-semibold hover:text-white",
              style: _normalizeStyle(item.style),
              onClick: ($event: any) => (selectTriage(item.id))
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: "rounded-full h-2 w-2 triage-circle",
                  style: _normalizeStyle(item.circleStyle)
                }, null, 4),
                _createElementVNode("div", null, _toDisplayString(item.name), 1)
              ])
            ], 12, _hoisted_9))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_away, clickAway]
  ])
}
}

})